import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * メール送信 API 操作クラス
 */
export default class SendMailMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST SendMessages
   */
  public async post(userStore: LoginUser, requestBody: SendMailMessagesPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendMailMessagesToFamily, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SendMailMessagesPostModel {
  /** ソートキー */
  sortKeys: Array<string>;
  /** 宛先名 */
  targetName: string;
  /** タイトル */
  subject: string;
  /** メッセージ */
  text: string;
  /** オプション文をつけるか */
  addOptionText: boolean;
  /** 見ましたをつけるか */
  addReadButton: boolean;
  /** 返信をつけるか */
  addReplyButton: boolean;
  /** 添付ファイルのS3URL */
  fileUrls: Array<string>;
  /** 添付ファイル名 */
  fileNames: Array<string>;
  /** 送信者ID */
  writerId: string;
  /** 送信者名 */
  writtenBy: string;
  /** 種別 */
  type: string;
  /** 受信メッセージURLを付与するか否か */
  addReceivedMessageUrl: boolean;
  /** DB登録するか否か */
  needDbRegister: boolean;
}
